import moment from "moment";

export const isPassedSessionKey = timeout =>
  moment().diff(moment(timeout)) ?? 0 >= 0;

export const checkKeyRoom = () => {
  const key = JSON.parse(localStorage.getItem("session-key"));
  const room = localStorage.getItem("room");
  return room && isPassedSessionKey(key?.timeout);
};
